import { utilsModule } from "../utils-module";

utilsModule.factory('loaderService',['$q','serverAddress','LoggedUserService','$http',function($q,serverAddress,LoggedUserService,$http){	

    var cachedList = undefined;

	return {

		list:function(){
			var deferred = $q.defer();

			$http.get(serverAddress.javaURL + '/carregador/get_all/' + LoggedUserService.loggedUser.id + 
                                        '/' + LoggedUserService.loggedUser.senha + 
                                        '?login_type='+LoggedUserService.type).then(function(resp){
                if (resp.data) {
                    deferred.resolve(resp.data);
                } else {
                    deferred.reject();
                }
            },function(){
                deferred.reject();
            })
            return deferred.promise;

		},

        listCached:function(){
            var deferred = $q.defer();

            if (!cachedList) {
                this.list().then(function(listed){
                    cachedList = listed;
                    deferred.resolve(listed);
                },function(){
                    deferred.reject();
                });
            }else{
                deferred.resolve(cachedList);
            }

            return deferred.promise;
        }
	};

}]);